import { useParams, Navigate } from 'react-router-dom';
import projectsData from '../data/projects.json';
import { getProjectCards } from '../config/projects.js';
import { usePageTransition } from '../context/TransitionContext.jsx';
import Cards from '../components/Cards.jsx';

const projectsBySlug = Object.fromEntries(projectsData.map(p => [p.slug, p]));

export default function CardPage() {
  const { slug, cardSlug } = useParams();
  const { navigateTo } = usePageTransition();
  const project = projectsBySlug[slug];

  if (!project) return <Navigate to="/projects" replace />;

  const cards = getProjectCards(slug);
  const card = cards?.find(c => c.slug === cardSlug);

  if (!card) return <Navigate to={`/projects/${slug}`} replace />;

  return (
    <section className="page-content">
      <h1><em>{card.title}</em></h1>
      {card.description && <p>{card.description}</p>}
      {card.iframeSrc && (
        <iframe
          src={card.iframeSrc}
          title={card.title}
          width="100%"
          scrolling="no"
          frameBorder="no"
          allow="autoplay"
        />
      )}
      {!card.iframeSrc && card.imageSrc && (
        <img src={card.imageSrc} alt={card.title} />
      )}
      {card.cards && card.cards.length > 0 && <Cards data={card.cards} />}
      <p style={{ marginTop: '2rem' }}>
        <button className="back-link" onClick={() => navigateTo(`/projects/${slug}`)}>
          ← Back to {project.title}
        </button>
      </p>
    </section>
  );
}
